import TWEEN from '@tweenjs/tween.js';
import {runIncremental} from './runIncremental';
import {AnimationPair, DeltaParams} from './types';

// 'delta' strategy — "move by this amount."
//
// Adds a permanent Δ shift on top of the live axis value via the shared
// incremental‑additive engine. Never reads the mesh's absolute value; only
// the caller‑supplied delta matters. Any concurrent writers to the same axis
// during the tween are preserved (their contributions sum with the tween's).
export const deltaStrategy = (params: DeltaParams): AnimationPair => {
    const {
        mesh,
        property,
        axis,
        openDelay = 0,
        closeDelay = 0,
        openDuration = 1000,
        closeDuration = 1000,
    } = params;

    const easing = params.easing ?? TWEEN.Easing.Quadratic.Out;

    const runDelta = (
        delta: number,
        duration: number,
        delayBeforeStart: number
    ) => {
        if (delta === 0) {
            return Promise.resolve();
        }
        return runIncremental({
            mesh,
            property,
            axis,
            duration,
            delayBeforeStart,
            easing,
            progressToOffset: (progress) => delta * progress,
            finalOffset: delta,
        });
    };

    return {
        open: (duration = openDuration) => {
            const {openDelta} = params.getDelta();
            return runDelta(openDelta, duration, openDelay);
        },
        close: (duration = closeDuration) => {
            const {closeDelta} = params.getDelta();
            return runDelta(closeDelta, duration, closeDelay);
        },
    };
};
